import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import bubbleGif from '../../../images/gif/bubble.gif';

const AboutHeader = () => {
    return (
        <div style={{backgroundImage: `url(${bubbleGif})`, backgroundSize: 'cover', backgroundPosition: 'center', color: 'white', padding: '20px 20px 200px 20px', borderRadius: 20}} className="text-center">
            <h4 data-aos="fade-up" data-aos-duration="1000" className="style-font">Be Event</h4>
            <h1 data-aos="fade-up" data-aos-duration="2000" className="fw-bolder">
                <span style={{ color: '#ff3465' }}>15 Years </span><br />
                <span style={{ fontSize: 20, padding: '0 3px', border: '2px solid gray', borderRadius: 5, color: '#ff3465' }}>of</span> Experience <br />
            </h1>
            <p data-aos="fade-up" data-aos-duration="2500">Erat scelerisque lobortis nisl sed elementum massa. Et eu viverra nisi, adipiscing mauris. Pulvinar phasellus mattis pellentesque posuere nunc.</p>
            <Link data-aos="fade-up" data-aos-duration="3000" to="#our-team" className="btn rounded-pill me-2 btn-global-style-solid">
                Book event <FontAwesomeIcon icon={faArrowRight} />
            </Link>
        </div>
    );
};

export default AboutHeader;